<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<h2 class="partnum"><span class="bold">PART ONE</span></h2>
<h2 class="parttitle"><span class="bold">A SAILOR I SHALL BE</span></h2>
<div class="quote">
<p class="noindentc"><em class="italic">I must go down to the seas again, to the vagrant gypsy life</em></p>
<p class="noindentr">– John Masefield</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?22eb123c